import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import React from "react";
import { useRetailerRoutingContext } from "@faire/retailer/RetailerRoutingContextProvider";
import { BannerContentTypography, NonEngContentWrapper, RotatingNonEngContent } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import { KEYWORDS, getURLFromKeyword } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/consts";
var getProductLink = function(chunks, linkTo) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: linkTo,
        style: {
            textDecorationThickness: "0.1em"
        },
        onClick: function() {
            trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("perfect_product_banner-product-link", linkTo);
        },
        children: /*#__PURE__*/ _jsx(BannerContentTypography, {
            style: {
                color: "unset"
            },
            children: chunks
        })
    });
};
export var NonEnglishContent = function() {
    var routingContext = useRetailerRoutingContext();
    return /*#__PURE__*/ _jsxs(NonEngContentWrapper, {
        "data-test-id": "non-english-content-wrapper",
        children: [
            /*#__PURE__*/ _jsx(RotatingNonEngContent, {
                index: 0,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "gRlJMn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Perfect "
                        },
                        {
                            type: 8,
                            value: "ProductLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "drinkware"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " for your store, right this way."
                        }
                    ],
                    values: {
                        ProductLinkFormatting: function(chunks) {
                            return getProductLink(chunks, getURLFromKeyword(KEYWORDS.DRINKWARE, routingContext));
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(RotatingNonEngContent, {
                index: 1,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "AkXPLL",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Perfect "
                        },
                        {
                            type: 8,
                            value: "ProductLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "planter"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " for your store, right this way."
                        }
                    ],
                    values: {
                        ProductLinkFormatting: function(chunks) {
                            return getProductLink(chunks, getURLFromKeyword(KEYWORDS.PLANTER, routingContext));
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(RotatingNonEngContent, {
                index: 2,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "0v3FGb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Perfect "
                        },
                        {
                            type: 8,
                            value: "ProductLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "moisturizer"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " for your store, right this way."
                        }
                    ],
                    values: {
                        ProductLinkFormatting: function(chunks) {
                            return getProductLink(chunks, getURLFromKeyword(KEYWORDS.MOISTURIZER, routingContext));
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(RotatingNonEngContent, {
                index: 3,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "szRWvu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Perfect "
                        },
                        {
                            type: 8,
                            value: "ProductLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "coffee"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " for your store, right this way."
                        }
                    ],
                    values: {
                        ProductLinkFormatting: function(chunks) {
                            return getProductLink(chunks, getURLFromKeyword(KEYWORDS.COFFEE, routingContext));
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(RotatingNonEngContent, {
                index: 4,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Ev8Hok",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The Perfect "
                        },
                        {
                            type: 8,
                            value: "ProductLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "candle"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " for your store, right this way."
                        }
                    ],
                    values: {
                        ProductLinkFormatting: function(chunks) {
                            return getProductLink(chunks, getURLFromKeyword(KEYWORDS.CANDLE, routingContext));
                        }
                    }
                })
            })
        ]
    });
};
